import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function AuthRecoveryShell({ eyebrow = "Votre espace", title, description, children }) {
  return (
    <main className="hrec-screen">
      <Link
        to="/auth/login"
        className="hrec-back"
        aria-label="Retour à la connexion"
      >
        <ArrowLeft
          size={20}
          strokeWidth={2}
        />
        <span>Retour</span>
      </Link>

      <div className="hrec-stage">
        <section
          className="hrec-content"
          aria-labelledby="hrec-title"
        >

          <p className="hrec-eyebrow">{eyebrow}</p>

          <h1
            id="hrec-title"
            className="hrec-title"
          >
            {title}
          </h1>

          <p className="hrec-description">{description}</p>

          <div className="hrec-body">{children}</div>
        </section>
      </div>

      <style>{`
.hrec-screen {
  position: fixed;
  inset: 0;
  z-index: 60;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  background: #ffffff;
  color: #203e3e;
}

.hrec-screen *,
.hrec-screen *::before,
.hrec-screen *::after {
  box-sizing: border-box;
}


.hrec-back {
  position: absolute;
  top: max(20px, calc(env(safe-area-inset-top, 0px) + 10px));
  left: max(18px, calc(env(safe-area-inset-left, 0px) + 10px));
  z-index: 4;
  min-height: 42px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.62);
  color: #506866;
  font-family: var(--font-sans, "DM Sans", sans-serif);
  font-size: 0.86rem;
  font-weight: 750;
  text-decoration: none;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  transition: background 180ms ease, color 180ms ease;
}

.hrec-back:hover {
  background: rgba(255, 255, 255, 0.94);
  color: #203e3e;
}

.hrec-stage {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  padding: max(64px, calc(env(safe-area-inset-top, 0px) + 54px)) 24px max(24px, env(safe-area-inset-bottom, 0px));
}

.hrec-content {
  width: min(100%, 560px);
  margin: 0 auto;
  text-align: center;
}

.hrec-eyebrow {
  margin: 0 0 10px;
  color: #61837a;
  font-family: var(--font-sans, "DM Sans", sans-serif);
  font-size: 0.71rem;
  font-weight: 850;
  line-height: 1;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.hrec-title {
  margin: 0;
  color: #203e3e;
  font-family: var(--font-display, "Nunito", sans-serif);
  font-size: clamp(2.1rem, 6vw, 3.25rem);
  font-weight: 850;
  line-height: 1.04;
  letter-spacing: -0.045em;
  text-wrap: balance;
}

.hrec-description {
  max-width: 490px;
  margin: 14px auto 0;
  color: #506866;
  font-family: var(--font-sans, "DM Sans", sans-serif);
  font-size: 0.98rem;
  font-weight: 500;
  line-height: 1.62;
  text-wrap: balance;
}

.hrec-body {
  width: min(100%, 500px);
  margin: 26px auto 0;
}

.hrec-form {
  width: 100%;
  display: grid;
  gap: 16px;
  text-align: left;
}

.hrec-group {
  margin: 0;
}

.hrec-label {
  display: block;
  margin: 0 0 7px 3px;
  color: #405b54;
  font-family: var(--font-sans, "DM Sans", sans-serif);
  font-size: 0.82rem;
  font-weight: 800;
}

.hrec-field {
  position: relative;
}

.hrec-field-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  z-index: 1;
  transform: translateY(-50%);
  color: #61837a;
  pointer-events: none;
}

.hrec-input {
  width: 100%;
  min-height: 56px;
  padding: 0 16px 0 46px;
  border: 1px solid rgba(97, 131, 122, 0.2);
  border-radius: 17px;
  outline: none;
  background: rgba(255, 255, 255, 0.86);
  color: #203e3e;
  caret-color: #61837a;
  font-family: var(--font-sans, "DM Sans", sans-serif);
  font-size: 1rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.96), 0 7px 22px rgba(49, 72, 66, 0.035);
  transition: border-color 180ms ease, background 180ms ease, box-shadow 180ms ease;
}

.hrec-input--password {
  padding-right: 48px;
}

.hrec-input::placeholder {
  color: rgba(80, 104, 102, 0.44);
}

.hrec-input:hover {
  border-color: rgba(97, 131, 122, 0.32);
  background: #ffffff;
}

.hrec-input:focus {
  border-color: rgba(97, 131, 122, 0.62);
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(118, 165, 167, 0.13), 0 10px 26px rgba(49, 72, 66, 0.06);
}

.hrec-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  z-index: 2;
  transform: translateY(-50%);
  padding: 5px;
  display: grid;
  place-items: center;
  border: 0;
  background: transparent;
  color: #61837a;
  cursor: pointer;
}

.hrec-toggle:hover {
  color: #203e3e;
}

.hrec-submit {
  width: 100%;
  min-height: 56px;
  margin-top: 2px;
  padding: 0 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(135deg, #61837a 0%, #76a5a7 100%);
  color: #ffffff;
  font-family: var(--font-sans, "DM Sans", sans-serif);
  font-size: 0.96rem;
  font-weight: 800;
  text-decoration: none;
  box-shadow: 0 15px 34px rgba(97, 131, 122, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.22);
  cursor: pointer;
  transition: transform 180ms ease, box-shadow 180ms ease, opacity 180ms ease;
}

.hrec-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 20px 42px rgba(97, 131, 122, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

.hrec-submit:active:not(:disabled) {
  transform: translateY(0);
}

.hrec-submit:disabled {
  opacity: 0.52;
  cursor: not-allowed;
  box-shadow: none;
}

.hrec-error {
  margin: 0;
  padding: 12px 14px;
  border: 1px solid rgba(168, 95, 85, 0.16);
  border-radius: 14px;
  background: rgba(168, 95, 85, 0.07);
  color: #874940;
  font-family: var(--font-sans, "DM Sans", sans-serif);
  font-size: 0.86rem;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
}

.hrec-note {
  margin: -2px 0 0;
  color: rgba(80, 104, 102, 0.72);
  font-family: var(--font-sans, "DM Sans", sans-serif);
  font-size: 0.78rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
}

.hrec-state {
  display: grid;
  justify-items: center;
  gap: 12px;
}

.hrec-state-icon {
  width: 58px;
  height: 58px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(97, 131, 122, 0.18);
  border-radius: 50%;
  background: rgba(203, 226, 219, 0.28);
  color: #4f756d;
}

.hrec-state-title {
  margin: 2px 0 0;
  color: #203e3e;
  font-family: var(--font-display, "Nunito", sans-serif);
  font-size: 1.45rem;
  font-weight: 850;
  line-height: 1.15;
  letter-spacing: -0.025em;
}

.hrec-state-text {
  max-width: 430px;
  margin: 0;
  color: #506866;
  font-family: var(--font-sans, "DM Sans", sans-serif);
  font-size: 0.91rem;
  font-weight: 500;
  line-height: 1.58;
}

.hrec-state-text strong {
  color: #405b54;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.hrec-state .hrec-submit {
  margin-top: 8px;
}

.hrec-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.32);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: hrecSpin 0.8s linear infinite;
}

.hrec-loader {
  width: 30px;
  height: 30px;
  border: 3px solid rgba(97, 131, 122, 0.16);
  border-top-color: #61837a;
  border-radius: 50%;
  animation: hrecSpin 0.85s linear infinite;
}

@keyframes hrecSpin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 600px) {
  .hrec-stage {
    padding-left: 18px;
    padding-right: 18px;
  }

  .hrec-back span {
    display: none;
  }

  .hrec-title {
    font-size: clamp(2rem, 10vw, 2.55rem);
  }

  .hrec-description {
    font-size: 0.9rem;
  }

  .hrec-body {
    margin-top: 24px;
  }
}

@media (max-height: 720px) {
  .hrec-stage {
    padding-top: max(58px, calc(env(safe-area-inset-top, 0px) + 50px));
    padding-bottom: max(16px, env(safe-area-inset-bottom, 0px));
  }

  .hrec-title {
    font-size: clamp(1.85rem, 7vw, 2.35rem);
  }

  .hrec-description {
    margin-top: 10px;
    font-size: 0.86rem;
    line-height: 1.45;
  }

  .hrec-body {
    margin-top: 18px;
  }

  .hrec-form {
    gap: 12px;
  }

  .hrec-input {
    min-height: 50px;
  }

  .hrec-submit {
    min-height: 51px;
  }
}

@media (hover: none) and (pointer: coarse) {
  .hrec-submit:hover:not(:disabled) {
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .hrec-screen *,
  .hrec-screen *::before,
  .hrec-screen *::after {
    animation: none !important;
    transition: none !important;
  }
}
      `}</style>
    </main>
  );
}